var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AlertCard from '@/components/alert-card/AlertCard';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { Template } from '@/models/Template';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { sanitizeString } from '@/support/String';
import { RolesEnum } from '@/items/Roles';
let EditDescriptionDialog = class EditDescriptionDialog extends Vue {
    constructor() {
        super(...arguments);
        this.description = '';
        this.templates = [];
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.fileInput = null;
        this.selectedFile = null;
        this.selectedTemplate = null;
        this.isTemplateFile = false;
    }
    get editorOptions() {
        return {
            placeholder: this.$t('summary.dialog.description.placeholder'),
            modules: {
                toolbar: true,
                magicUrl: true,
            },
        };
    }
    mounted() {
        const subjectIds = this.subjectIds;
        if (subjectIds.length === 1) {
            new Template()
                .subject(subjectIds[0])
                .include('file')
                .all()
                .then((templates) => {
                this.templates = templates;
            });
        }
    }
    submit() {
        if (this.description.length <= 0) {
            return;
        }
        this.isSubmitting = true;
        const payload = {
            user_subjects: this.userSubjectIds,
            description: this.description,
        };
        if (this.selectedTemplate) {
            payload.template = this.selectedTemplate;
        }
        else if (this.selectedFile) {
            payload.collection = 'default';
            payload.file = this.selectedFile;
        }
        new UserSubject()
            .bulkUpdateDescription(payload)
            .then(() => {
            this.isSubmitting = false;
            this.isSubmitted = true;
            this.$emit('description-changed');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    onFileChange(event) {
        if (!event.target.files.length === null) {
            return;
        }
        this.fileInput = event.target;
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
    }
    removeSelectedFile() {
        this.selectedFile = null;
        this.selectedTemplate = null;
        if (this.fileInput) {
            this.fileInput.removeAttribute('value');
            this.fileInput.setAttribute('value', '');
        }
    }
    clear() {
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.description = '';
        this.fileInput = null;
        this.selectedFile = null;
        this.selectedTemplate = null;
        this.isTemplateFile = false;
    }
    isSubmittingChanged(isSubmitting, wasUploading) {
        if (isSubmitting) {
            this.takingTooLongTimeout = setTimeout(() => {
                this.isTakingTooLong = true;
            }, 30000);
        }
        else {
            this.isTakingTooLong = false;
            clearTimeout(this.takingTooLongTimeout);
        }
    }
    isSubmittedChanged(isSubmitted, wasSubmitted) {
        if (isSubmitted) {
            this.$emit('description-changed');
        }
    }
    getTemplates(id) {
        if (this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT]) && !this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER])) {
            return;
        }
        new Template()
            .subject(id)
            .include('file')
            .all()
            .then((templates) => {
            this.templates = templates;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    selectTemplate(template) {
        this.selectedTemplate = template.id || null;
        if (!template.value) {
            return;
        }
        this.description = template.value;
        if (template.file && template.file.links && template.file.links.download) {
            this.selectedFile = template.file;
            this.isTemplateFile = true;
        }
    }
    closeDialog() {
        this.clear();
        this.$emit('input', false);
    }
    subjectIdsChanged(subjectIds) {
        if (subjectIds.length === 1) {
            this.getTemplates(subjectIds[0]);
        }
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
    createFilePayload() {
        const payload = {
            file: this.isTemplateFile ? this.selectedFile.links.download : this.selectedFile,
            collection: 'default',
        };
        return payload;
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], EditDescriptionDialog.prototype, "userSubjectIds", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], EditDescriptionDialog.prototype, "userIds", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], EditDescriptionDialog.prototype, "subjectIds", void 0);
__decorate([
    Watch('isSubmitting'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], EditDescriptionDialog.prototype, "isSubmittingChanged", null);
__decorate([
    Watch('isSubmitted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], EditDescriptionDialog.prototype, "isSubmittedChanged", null);
__decorate([
    Watch('subjectIds'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], EditDescriptionDialog.prototype, "subjectIdsChanged", null);
EditDescriptionDialog = __decorate([
    Component({
        components: {
            AlertCard,
            quillEditor,
        },
    })
], EditDescriptionDialog);
export default EditDescriptionDialog;
